// extracted by mini-css-extract-plugin
export default {"productGallery":"jM-z","inQuickShop":"kM-z"};